import React from 'react';
import styled from 'styled-components';
import {device} from '../../assets/device'
import merchantConfig from '../../merchant/config/merchant-config';

export const EventTicketButtonStyles = {
	Container: styled.div`
      display: flex;
      justify-content: flex-end;
      vertical-align: baseline;
      margin: 1em 0 0 0;
      width: 100%;
      //noinspection ALL
      @media ${device.tablet} {
        margin: 0;
      }
	`,
	Button: styled.a`
      background-color: darkred;
      border: 1px solid rgba(0, 0, 0, .3);
      border-radius: 2px;
      box-sizing: content-box;
      color: white;
      cursor: pointer;
      display: inline-block;
      font-size: 1em;
      font-weight: 600;
      outline: none;
      height: 2.8em;
      line-height: 2.8em;
      text-align: center;
      text-decoration: none;
      text-transform: none;
      padding: 0 1em;
      font-family: "Open Sans", sans-serif;
      width: 100%;
      //noinspection ALL
      @media ${device.tablet} {
        font-size: 1em;
      }

      &:hover {
        border: 1px solid rgba(0, 0, 0, .5);
        //box-shadow: rgba(0,0,0,.2) 0 1px 6px, rgba(0,0,0,.2) 0 1px 4px
      }

      .ticket__icon {
        vertical-align: middle;
        font-size: 1.5em;
        margin-right: .3em;
        margin-bottom: .1em;
        //noinspection ALL
        @media ${device.tablet} {
          font-size: 1.3em;
        }
      }

      &.icon-button {
        .ticket__icon {
          margin: 0;
        }
      }
	`,
	SoldOut: styled.div`
      background-color: lightgray;
      border: 1px solid #484646;
      border-radius: 2px;
      box-sizing: content-box;
      color: red;
      display: inline-block;
      font-size: 1em;
      font-weight: 600;
      outline: none;
      height: 2.8em;
      line-height: 2.8em;
      text-align: center;
      text-decoration: none;
      text-transform: none;
      padding: 0 1em;
      font-family: "Open Sans", sans-serif;
      width: 100%;
      //noinspection ALL
      @media ${device.tablet} {
        font-size: 1em;
      }

      .block__icon {
        vertical-align: middle;
        font-size: 1.5em;
        margin-right: .3em;
        margin-bottom: .1em;
        //noinspection ALL
        @media ${device.tablet} {
          font-size: 1.3em;
        }
      }
	`,
};

const S = EventTicketButtonStyles;

const onlineSaleBaseUrl = merchantConfig.pcuiBaseUrl;

const EventTicketButton = props => {
	const showButton = !merchantConfig.pcuiBookingOfficeUuid || !props.event.availableByBoUuid || props.event.availableByBoUuid[merchantConfig.pcuiBookingOfficeUuid] === true;
	const soldOutElement =
		<S.SoldOut>
			<i className="material-icons block__icon">block</i>Ausverkauft
		</S.SoldOut>;
	const buttonEl = (props.iconButton ?
		<S.Button
			className="icon-button"
			href={`${onlineSaleBaseUrl}/${props.event.uuid}`}
			target="_top"
		>
			<i className="material-icons ticket__icon">local_play</i>
		</S.Button> :
		<S.Button
			href={`${onlineSaleBaseUrl}/${props.event.uuid}`}
			target="_top"
		>
			<i className="material-icons ticket__icon">local_play</i><span>Ticket kaufen</span>
		</S.Button>);
	return (
		<S.Container>
			{showButton ? buttonEl : soldOutElement}
		</S.Container>
	);
};

export default EventTicketButton;
